export default {
    BIT: {
        desc: 'Битовое число, содержащее заданное количество битов',
        sub1: 1
    },
    BOOLEAN: {
        syn: ['BOOL'],
        desc: 'Boolean field',
        enum: ['FALSE', 'TRUE']
    },
    TINYINT: {
        desc: 'Целое число',
        sub1: 10,
        min: '-128',
        max:  '127',
        maxp: '255',
        unsigned: true
    },
    SMALLINT: {
        desc: 'Целое число',
        sub1: 10,
        min: '-32 768',
        max:  '32 767',
        maxp: '65 535',
        unsigned: true
    },
    MEDIUMINT: {
        desc: 'Целое число',
        sub1: 10,
        min:  '-8 388 608',
        max:   '8 388 607',
        maxp: '16 777 215',
        unsigned: true
    },
    INT: {
        syn: ['INTEGER'],
        desc: 'Целое число',
        sub1: 10,
        min: '-2 147 483 648',
        max:  '2 147 483 647',
        maxp: '4 294 967 295',
        unsigned: true
    },
    BIGINT: {
        desc: 'Целое число',
        sub1: 10,
        min:  '-9 223 372 036 854 775 808',
        max:   '9 223 372 036 854 775 807',
        maxp: '18 446 744 073 709 551 615',
        unsigned: true
    },
    FLOAT: {
        desc: 'Вещественное число с точностью около 7 значащих цифр',
        sub1: 10,
        min: '-3,402823466**38',
        max:  '3,402823466**38',
        unsigned: true
    },
    DOUBLE: {
        syn: ['DOUBLE PRECISION', 'REAL'],
        desc: 'Вещественное число с точностью около 15 значащих цифр',
        sub1: 10,
        min: '-1,7976931348623157**308',
        max:  '1,7976931348623157**308',
        unsigned: true
    },
    DECIMAL: {
        syn: ['DEC', 'NUMERIC', 'FIXED'],
        desc: 'Точное число с фиксированной точкой (до 65.30 цифр).',
        sub1: 10,
        sub2: 0,
        unsigned: true
    },
    YEAR: {
        sub1: 4,
        min:  '1901',
        max:  '2155',
        form: 'YYYY'
    },
    DATE: {
        min:  '0000-01-01',
        max:  '9999-12-31',
        form: 'YYYY-MM-DD'
    },
    TIME: {
        min: '-838:59:59',
        max:  '838:59:59',
        form: 'HH:MM:SS'
    },
    DATETIME: {
        min:  '0000-01-01 00:00:00',
        max:  '9999-12-31 23:59:59',
        form: 'YYYY-MM-DD HH:MM:SS'
    },
    TIMESTAMP: {
        desc: 'Отметка времени DATETIME. При добавлении или изменении строки таблицы в столбце с типом TIMESTAMP автоматически устанавливается дата и время выполнения операции (если значение этого столбца не указано явно или указано неопределенное значение). Если нужно, чтобы отметка времени проставлялась только при добавлении строки, после слова TIMESTAMP добавим свойство DEFAULT CURRENT_TIMESTAMP. Если в таблице есть несколько столбцов с типом TIMESTAMP, отметка времени автоматически проставляется только в первом из них. Если необходимо также вносить отметку времени в какой-либо из последующих столбцов с типом TIMESTAMP, то при добавлении/изменении строки укажем для этого столбца значение NULL, которое будет автоматически заменено текущей датой.',
        min:  '1970-01-01 00:00:00',
        max:  '2038 year',
        form: 'YYYY-MM-DD HH:MM:SS'
    },
    CHAR: {
        desc: 'Символьная строка фиксированной длины',
        sub1: 1
    },
    VARCHAR: {
        desc: 'Символьная строка переменной длины, содержащая не более указанного количества символов',
        sub1: 1
    },
    BINARY: {
        desc: 'Байтовая (бинарная) строка фиксированной длины',
        sub1: 1
    },
    VARBINARY: {
        desc: 'Байтовая (бинарная) строка переменной длины',
        sub1: 1
    },
    BLOB: {
        desc: 'Байтовая (бинарная) строка переменной длины. Если количество байтов указано, то создается столбец с типом данных TINYBLOB, BLOB, MEDIUMBLOB или LONGBLOB: выбирается тип данных с наименьшим размером, достаточным для хранения этого количества байтов',
        sub1: 65535
    },
    TINYBLOB: {
        desc: 'Байтовая (бинарная) строка переменной длины',
        max: '255'
    },
    MEDIUMBLOB: {
        desc: 'Байтовая (бинарная) строка переменной длины',
        max: '16 777 215'
    },
    LONGBLOB: {
        desc: 'Байтовая (бинарная) строка переменной длины',
        max: '4 294 967 295' // 4 Gb
    },
    TEXT: {
        desc: 'Символьная строка переменной длины. Если количество символов указано, то создается столбец с типом данных TINYTEXT, TEXT, MEDIUMTEXT или LONGTEXT: выбирается тип данных с наименьшим размером, достаточным для хранения этого количества символов',
        sub1: 65535
    },
    TINYTEXT: {
        desc: 'Символьная строка переменной длины',
        max: '255'
    },
    MEDIUMTEXT: {
        desc: 'Символьная строка переменной длины',
        max: '16 777 215'
    },
    LONGTEXT: {
        desc: 'Символьная строка переменной длины',
        max: '4 294 967 295' // 4 Gb
    },
    ENUM: {
        sub1: '',
        sub2: '',
        desc: 'Строка, содержащая ровно один элемент из заданного списка или пустую строку',
        max: '65 535' // elements in list
    },
    SET: {
        desc: 'Строка, содержащая любой набор элементов из заданного списка или пустую строку или NULL',
        max: '64' // elements in list
    },
    SERIAL: {
        syn: ['BIGINT UNSIGNED NOT NULL AUTO_INCREMENT UNIQUE']
    },
}



// WEBPACK FOOTER //
// ./src/database/utils/data_types_mysql.js